<template>
    <Modal v-if="shown"
		   :title="$t('revolvingPutOption.assignmentConfirmations.modal.title')"
		   :width="600"
           :close-on-click-outside="false"
           @close="close()"
    >
        <template v-slot:body>
            <div class="flex flex_column modal-content">
				<RevolvingPutOptionShortInfo :option-data="data"/>
				<div class="margin_top">
					<h4 class="info_title small_margin">{{$t('revolvingPutOption.assignmentConfirmationsList')}}</h4>
					<AllInvestmentsRevolvingPutOptionsAssignmentConfirmationsTable :confirmations="confirmations" @confirm-assignment="confirmConfirmAssignment"/>
				</div>
			</div>
            <div class="flex flex_end margin_top">
                <md-button class="md-blank" @click="close()">{{ $t("common.button.close") }}</md-button>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from "@/components/templates/modal/Modal";
import {revolvingPutOptionsBuyerApi} from "@/common/api/revolvingPutOptionsBuyerApi";
import RevolvingPutOptionShortInfo from "@/components/templates/modal/revolvingPutOption/RevolvingPutOptionShortInfo";
import AllInvestmentsRevolvingPutOptionsAssignmentConfirmationsTable
	from "@/components/templates/investor/allInvestments/revolving/AllInvestmentsRevolvingPutOptionsAssignmentConfirmationsTable";

export default {
    components: {
		AllInvestmentsRevolvingPutOptionsAssignmentConfirmationsTable,
    	Modal,
		RevolvingPutOptionShortInfo
	},
    data() {
        return {
            shown: false,
			offerId: null,
			data: null,
			confirmedCount: 0,
        };
    },
	computed: {
    	confirmations() {
    		return this.data ? this.data.confirmations : [];
		}
	},
    methods: {
        show() {
            this.shown = true;
        },
		close() {
        	this.shown = false;

        	if (this.confirmedCount > 0) {
				this.$emit("confirmed");
			}
		},
		showWithOffer(offerId) {
        	this.data = null;
        	this.confirmedCount = 0;
			this.offerId = offerId;
			this.loadData();
        	this.show();
		},
		loadData() {
        	revolvingPutOptionsBuyerApi.inspection.getAssignmentConfirmations(this.offerId)
				.then((res) => {
					this.data = res;
				})
				.catch(this.toast);
		},
		confirmConfirmAssignment(data) {
			let option = {
				title: this.$t("allInvestments.revolvingPutOption.confirmAssignment.confirm.title"),
				msg: this.$t("allInvestments.revolvingPutOption.confirmAssignment.confirm.msg"),
				confirmFun: this.confirmAssignment,
				params: data
			};
			this.confirmMeg(option, true);
		},
		confirmAssignment(data) {
			revolvingPutOptionsBuyerApi.operation.confirmAssignment(data.id, data.settlementPrice)
				.then(() => {
					this.confirmedCount++;
					this.toastSuccess();
					this.loadData()
				}).catch(this.toast);
		},
    },
};
</script>